<div id="app">
  <!-- SVG Visualization -->
  <svg #visualization id="visualization"></svg>

  <!-- Controls -->
  <!-- <div id="controls">
    <button id="next-tier" (click)="nextTier()">Next Tier</button>
  </div> -->

  <!-- Fullscreen Modal -->
  <div id="fullscreen-controls" [class.hidden]="!showFullscreenModal">
    <div class="fullscreen-container">
      <div class="corner-box">
        <div class="inner-corners"></div>
      </div>
      <button id="toggleFullscreen" (click)="toggleFullscreen()">Enter Fullscreen</button>
      <div id="fullscreen-cancel" class="close-icon" (click)="toggleFullscreenModal(true)"></div>
    </div>
  </div>

  <!-- Navigation Wrapper -->
  <div id="p-nav-wrapper" class="container" (click)="onDocumentClick()" *ngIf="!showFullscreenModal">
    <!-- Left Navigation -->
    <div class="child-nav-wrapper" id="navLeftContainer">
      <!-- <div style="position: relative;"> -->
        <button 
          id="navLeft" 
          class="btn btn-primary col col-sm-4 col-md-12 text-nowrap"
          *ngIf="showNavLeft"
          (click)="navigateLeft($event)">
          {{ navLeftText | slice:0:maxLabelLength }} {{ navLeftText.length > maxLabelLength ? '...' : '' }}
        </button>
        <div 
          id="navLeftDropup" 
          class="dropup-menu btn btn-primary col col-sm-4 text-nowrap"
          [class.show]="showDropup"
          [class.invisible]="!showDropup && dropupItems.length === 0">
          <div 
            *ngFor="let item of dropupItems"
            class="dropup-item text-nowrap"
            (click)="onDropupItemClick(item.nodeId)">
            {{ item.label }}
          </div>
        <!-- </div> -->
        </div>
        <button 
          id="restart" 
          class="btn btn-secondary col col-sm-4 text-nowrap"
          *ngIf="endOfPath"
          (click)="navigateToStart()">
          Restart
        </button>
    </div>

    <!-- Center Navigation -->
    <div class="child-nav-wrapper">
      <!-- <button 
        id="navCenter" 
        *ngIf="showNavCenter"
        (click)="navigateCenter()">
        {{ navCenterText }}
      </button> -->
      <div
         id="navCenter" 
        *ngIf="showNavCenter"
        (click)="showDetails()">
        <!-- <img id="centerBtn" src="../../../../assets/images/icons/square-only.svg" /> -->
         <div class="act-button-outer">
            <div class="act-button-inner" [ngClass]="{nudge: inMotion}"></div>
         </div>
      </div>
    </div>

    <!-- Right Navigation -->
    <div class="child-nav-wrapper">
      <button 
        id="navRight"
        class="btn btn-primary col col-sm-4 col-md-12 text-nowrap" 
        *ngIf="showNavRight"
        (click)="navigateRight()">
        {{ navRightText | slice:0:maxLabelLength }} {{ navRightText.length > maxLabelLength ? '...' : '' }}
      </button>
      <button 
          id="complete" 
          class="btn btn-primary col col-sm-4 text-nowrap"
          *ngIf="endOfPath"
          (click)="viewSummary()">
        Summarize
        </button>
    </div>
  </div>
<!-- 
  <app-path-navigation
        [(showNav)]="true"
        [data]="data"
        [leftPath]="leftPath"
        [additionalPaths]="additionalPaths"
        (onNextRung)="onNextRungHandler($event)"
        (onComplete)="onCompleteHandler($event)"
        >
</app-path-navigation> -->

  <!-- Circle Info Modal -->
  <!-- <div 
    id="circleModal" 
    class="modal-overlay"
    [class.hidden]="!showCircleModal"
    (click)="hideCircleModal()">
    <div 
      class="modal-content"
      [style.top.px]="modalPosition.top"
      [style.left.px]="modalPosition.left"
      (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 id="modalLabel">{{ modalContent.label }}</h2>
        <span class="modal-close" id="modalClose" (click)="hideCircleModal()">&times;</span>
      </div>
      <div class="modal-body">
        <p id="modalText" style="white-space: pre-line;">{{ modalContent.text }}</p>
      </div>
    </div>
  </div> -->
</div>
